import useHasFooter from "@/lib/client/hooks/useHasFooter";
import { useLayoutContext } from "../../lib/client/contexts/LayoutContext";
import { useEffect } from "react";
import { Button } from "@/components/ui/Button";
import clsx from "clsx";
import { useTranslations } from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/contexts/TranslationContext";
import { useLauncherStore } from "../../../lib/client/contexts/LauncherStoreContext";

export default function TabsErrorRetry({
  translatedErrorText,
  translatedRetryText,
  hasHeader = true,
  reset,
  error,
}: {
  hasHeader?: boolean;
  translatedErrorText?: string;
  translatedRetryText?: string;
  error: unknown;
  reset: () => void;
}) {
  const hasFooter = useHasFooter();
  const { setPageRendered } = useLayoutContext();
  const authStatus = useLauncherStore((state) => state.authStatus);
  const t = useTranslations();

  useEffect(() => {
    window.Sentry && window.Sentry.captureException(error);
    console.error(error);
  }, [error]);

  useEffect(() => {
    setPageRendered(true);
  }, [setPageRendered]);

  return (
    <div
      className={clsx(
        "TabsErrorRetry flex h-full flex-col items-center justify-center gap-4 bg-white dark:bg-gray-700",
        !hasHeader && "rounded-t-inherit",
        !hasFooter && "rounded-b-inherit",
      )}
    >
      <h2 className="font-semibold text-gray-500 dark:text-gray-200">
        {authStatus === "error" ? t("Error.auth") : translatedErrorText ?? t("Error.generic_error")}
      </h2>
      <div className="flex gap-2">
        <Button
          color="primary"
          onClick={() => {
            reset();
          }}
        >
          {translatedRetryText ?? t("Error.retry")}
        </Button>
      </div>
    </div>
  );
}
